var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","value-key":"uuid","value":_vm.value,"placeholder":"请选择诉讼主体","clearable":_vm.clearable},on:{"change":_vm.change}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.uuid,attrs:{"label":item.name,"value":item.uuid}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }